export const educationData = [
  {
    id: 1,
    institution: "Indian Institute of Information and Technology,TamilNadu",
    course: "Bachelor of Technology",
    startYear: "2020",
    endYear: "2024",
  },

  {
    id: 2,
    institution: "State Board, Maharashtra.",
    course: "Higher Secondary School Certificate(XII)",
    startYear: "2018",
    endYear: "2020",
  },
  {
    id: 3,
    institution: "Kendriya Vidyalaya CRPF Mudkhed, Nanded",
    course: "Secondary School Certificate(X)",
    startYear: "2010",
    endYear: "2018",
  },
];
